import React from 'react';
import Navbar from './Navbar';
import {
    makeStyles, Hidden
} from '@material-ui/core';
import Cajon from './Cajon';
import Dashboard from '../pages/Dashboard';

const estilos = makeStyles(theme => ({
    root: {
        display: 'flex',
        paddingTop: '65px',
        width: '100%'
    },
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(1),
    },
}))

const Contenedor = () => {

    const classes = estilos()
    const [abrir, setAbrir] = React.useState(false)

    const accionAbrir = () => {
        setAbrir(!abrir)
    }

    return (
   
        <div className={classes.root}>
            <Navbar accionAbrir={accionAbrir} />
            <Hidden xsDown>
                <Cajon
                    variant="permanent"
                    open={true}
                />
            </Hidden>
            <Hidden smUp>
                <Cajon
                    variant="temporary"
                    open={abrir}
                    onClose={accionAbrir}
                />
            </Hidden>
           
               
               <Dashboard />
            
           
        </div>
     
    )
}

export default Contenedor;
